/**
 * Échelle d'élévation Odys — TROIS valeurs, pas une de plus (arbitrage P0.6,
 * issue #2503). L'audit avait relevé 5+ recettes d'ombre concurrentes dans les
 * apps (`2px 2px 10px…`, `0 4px 16px…`, `0px 0px 30px 10px…`) alors que
 * `theme.shadows` n'était jamais consommé.
 *
 * Valeurs reprises littéralement des recettes catalog/odys en place, pour que
 * l'adoption des tokens ne change rien au rendu des surfaces déjà correctes :
 *
 * - `card` — `ItineraryCard` / `ProductCardBody` au repos ;
 * - `cardHover` — les mêmes au survol. C'est aussi la cible des 4 copies de
 *   `2px 2px 10px 0px rgba(0,0,0,0.06)` (`DmcCard`, `DestinationCard`,
 *   `CategoryCard`, `ProjectCard`), dont le décalage horizontal était
 *   accidentel : leur survol changera légèrement à l'adoption (issue #2518) ;
 * - `overlay` — couches flottantes (menus, popovers, drawers). Valeur de
 *   `RecordPopover` (odys), médiane des recettes observées. Le mégamenu de
 *   catalog (`0 4px 20px rgba(0,0,0,0.24)`) est calibré pour se détacher d'un
 *   visuel plein écran : il garde son ombre locale plutôt que d'alourdir le
 *   token par défaut.
 *
 * Exposée sous `theme.elevation` — et non sous `theme.shadows`, qui est le
 * tableau indexé de MUI (26 entrées, `boxShadow: 3`) : y écraser trois indices
 * n'aurait donné aucun nom aux valeurs, ce qui est tout l'objet du token.
 * Usage : `sx={{ boxShadow: theme => theme.elevation.card }}`.
 */
export const elevation = {
  card: "0 4px 16px rgba(0,0,0,0.04)",
  cardHover: "0 8px 28px rgba(0,0,0,0.08)",
  overlay: "0 4px 24px rgba(0,0,0,0.15)",
} as const;

export type ElevationScale = typeof elevation;
export type ElevationToken = keyof ElevationScale;
